import { t } from "components/CentralDataMangement/translation/Translation";
import Title from "components/common/atoms/Title";
import GetQueryParams from "components/common/services/GetQueryParams";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import {
  createQueryParams,
  filterAndMerge,
  getQueryParamsFromRedux,
} from "components/common/utlis/HelperFunctions";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "store";
import { useDispatch } from "react-redux";
import {
  clearDestinationPath,
  setDestinationPath,
} from "features/NavigationSlice";
import { createFilterConfig } from "./Filters";
import SpinnerWrapper from "components/common/atoms/SpinnerWrapper";
import NoRecords from "components/common/atoms/NoRecords";
import PaginationNew from "components/common/atoms/PaginationNew";
import { Link } from "react-router-dom";
import Sorting from "components/common/atoms/Sorting";
import { ApiCall } from "components/common/services/ApiServices";
import { AJ_WEB_CONNECTOR } from "Constants";
import { GET_WHATSAPP_INSTANCE } from "../../../../routes/ApiEndpoints";
import LinkIcon from "static/images/LinkIcon";
import Button from "components/common/atoms/Button";
import InstancePopup from "./InstancePopup";
import { selectAuth } from "features/auth/AuthSlice";
import CustomNotify from "components/common/atoms/CustomNotify";

export interface Data {
  mobNumber: string;
  userName: string;
  instanceId: string;
  status: string;
}
export interface SearchProps {
  userName: string;
  instanceId: number | null;
  status: boolean;
  orderByColumn: string;
  orderIn: "" | "asc" | "desc"; // Ensure correct typing here
  currentPage: number;
  recordsPerPage: number;
}
const ManageWhatsappInstance = () => {
  const dispatch = useDispatch();
  const destinationPath = useSelector(
    (state: RootState) => state.navigation.destinationPath
  );
  const authUser = useSelector(selectAuth);
  const isInstanceActive = authUser.isInstanceReady ?? false;
  const getUrlParams = GetQueryParams();
  const paramFilter = getUrlParams.get("filter");
  const queryParams = getQueryParamsFromRedux(destinationPath, paramFilter);
  const [data, setData] = useState<Data[]>([]);
  const defaultSearchData: SearchProps = {
    userName: "",
    instanceId: null,
    status: false,
    orderByColumn: "",
    orderIn: "",
    currentPage: 1,
    recordsPerPage: 10,
  };

  const filteredSearchData = filterAndMerge(defaultSearchData, queryParams);
  const filters = createFilterConfig();

  const [searchData, setSearchData] = useState<SearchProps>({
    ...defaultSearchData,
    ...filteredSearchData,
  });
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState({
    totalPages: 1,
    totalRecords: 0,
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const filterData = { ...searchData };
    const searchUrl = createQueryParams(filterData);
    dispatch(setDestinationPath(searchUrl));
    setLoading(true);
    if (isInstanceActive) {
      setShowModal(false);
    }
    const delayDebounceFn = setTimeout(() => {
      fetchDetails(filterData);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchData, isInstanceActive]);

  const fetchDetails = async (filterData: any) => {
    setLoading(true);
    const data = {
      search: filterData,
    };
    const response = await ApiCall.service(
      GET_WHATSAPP_INSTANCE,
      "POST",
      data,
      false,
      AJ_WEB_CONNECTOR
    );
    if (response?.status === 200) {
      const { instanceData } = response?.data;
      setData(instanceData);
      setPaginationData(paginationData);
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occured"),
      });
    }
    setLoading(false);
  };

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setSearchData((prevSearch) => ({
      ...prevSearch,
      currentPage: 1,
      [name]: value,
    }));
  };

  const handleItemsPerPageChange = (newItemsPerPage: number) => {
    setSearchData((prev) => ({
      ...prev,
      recordsPerPage: newItemsPerPage,
      currentPage: 1,
    }));
  };

  const handleOrderByColumn = (column: string) => {
    let newOrder: "" | "asc" | "desc" = ""; // Explicit type declaration
    let newColumn = column;

    if (searchData.orderByColumn === column) {
      // Cycle through the three possible order values: '', 'asc', 'desc'
      if (searchData.orderIn === "") {
        newOrder = "asc"; // From '' to 'asc'
      } else if (searchData.orderIn === "asc") {
        newOrder = "desc"; // From 'asc' to 'desc'
      } else {
        newOrder = ""; // From 'desc' to ''
        newColumn = ""; // Reset column if no order
      }
    } else {
      // If it's a new column, start with ascending
      newOrder = "asc";
    }

    setSearchData((prevSearch) => ({
      ...prevSearch,
      currentPage: 1, // Reset pagination on sort change
      orderByColumn: newColumn, // Set the new column or empty string
      orderIn: newOrder, // Set the new order (asc, desc, or empty)
    }));
  };

  const handleReset = async () => {
    dispatch(clearDestinationPath());
    setSearchData(defaultSearchData);
    // fetchDetails will be called by useEffect due to searchData change
  };

  const handlePageChange = (pageNumber: number) => {
    setSearchData((prevSearch) => ({
      ...prevSearch,
      currentPage: pageNumber,
    }));
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModal = () => {
    setShowModal(true);
  };

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Whatsapp instance",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <div className={`main-container`}>
        <Title title={t("Whatsapp instance")} />
        <div className="form-height-dashboard">
          <div className="position-relative tableMainWrapper">
            <div className="table-responsive tableSection">
              {/* <table className="table manageWhatsappUsers border-0 mb-0">
                <thead>
                  <tr className="tableSearchFields">
                    <SearchFields
                      searchData={searchData}
                      filters={filters}
                      handleSearchChange={handleSearchChange}
                    />
                    <th className="border-0">
                      <div className="d-flex align-items-center w-100">
                        <ResetBtn handleResetClick={handleReset} />
                      </div>
                    </th>
                  </tr>
                </thead>
              </table> */}
              <div className="manageWhatsappInstanceWrapper scrollBarDesign">
                <table className="table table-hover manageWhatsappInstance">
                  <thead>
                    <tr className="TableHeader">
                      <th onClick={() => handleOrderByColumn("user_name")}>
                        {t("Username")}
                        {/* <Sorting
                          sortType={
                            searchData.orderByColumn === "user_name"
                              ? searchData.orderIn
                              : ""
                          }
                        /> */}
                      </th>
                      <th>{t("Mobile number")}</th>
                      <th onClick={() => handleOrderByColumn("instance_id")}>
                        {t("Instance Id")}
                        {/* <Sorting
                          sortType={
                            searchData.orderByColumn === "instance_id"
                              ? searchData.orderIn
                              : ""
                          }
                        /> */}
                      </th>
                      <th>{t("Status")}</th>
                      <AccessControl
                        requiredPermissions={[
                          {
                            permission: "Whatsapp instance",
                            update: true,
                            delete: true,
                          },
                        ]}
                        actions={true}
                        strict={false}
                      >
                        <th>{t("Action")}</th>
                      </AccessControl>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <SpinnerWrapper headerLength={5} />
                    ) : (
                      <>
                        {data && data.length > 0
                          ? data.map((user: Data, index: number) => (
                            <tr
                              key={index}
                              className="border box-shadow align-middle"
                            >
                              <td
                                className="text-break"
                                data-label={t("User Name")}
                              >
                                {user.userName}
                              </td>
                              <td
                                className="text-break"
                                data-label={t("User Name")}
                              >
                                {user.mobNumber}
                              </td>
                              <td
                                className="text-break"
                                data-label={t("Instance Id")}
                              >
                                {user.instanceId}
                              </td>
                              <td
                                className="text-break"
                                data-label={t("Status")}
                              >
                                <span
                                  className={`d-inline-block rounded-circle status-icon ${user.status === "success"
                                      ? "bg-success"
                                      : "bg-danger"
                                    }`}
                                  data-toggle="tooltip"
                                  title={
                                    user.status === "success"
                                      ? t("Active")
                                      : t("Inactive")
                                  }
                                ></span>
                              </td>
                              <AccessControl
                                requiredPermissions={[
                                  {
                                    permission: "Whatsapp instance",
                                    delete: true,
                                    update: true,
                                  },
                                ]}
                                actions={true}
                                strict={false}
                              >
                                <td className="table-action-icons">
                                  <AccessControl
                                    requiredPermissions={[
                                      {
                                        permission: "Whatsapp instance",
                                        update: true,
                                      },
                                    ]}
                                  >
                                    <Button
                                      className="border-0 bg-transparent"
                                      handleClick={() => handleModal()}
                                    >
                                      <LinkIcon />
                                    </Button>
                                  </AccessControl>
                                </td>
                              </AccessControl>
                            </tr>
                          ))
                          : !loading && <NoRecords headerLength={5} />}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              {!loading && paginationData.totalRecords > 0 && (
                <div className="pagination d-block">
                  <PaginationNew
                    currentPage={searchData.currentPage}
                    totalPages={paginationData.totalPages}
                    totalRecords={paginationData.totalRecords}
                    recordsPerPage={searchData.recordsPerPage}
                    onItemsPerPageChange={handleItemsPerPageChange}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="col-md-6 align-self-center"
          style={{ padding: "1vw 0" }}
        >
          <Link to="/dashboard" className=" back-btn text-decoration-underline">
            {t("Back")}
          </Link>
        </div>
        <InstancePopup
          handleModalClose={handleModalClose}
          showModal={showModal}
        />
      </div>
    </AccessControl>
  );
};

export default ManageWhatsappInstance;
